import styled from 'styled-components';
import { ThemeInterface } from '../../interfaces/themeInterface';

const getOppositeBackground = (theme: ThemeInterface) =>
  theme.name === 'long' ? 'blue' : '#ffccd5';

const getOppositeText = (theme: ThemeInterface) => (theme.name === 'long' ? 'white' : 'black');

export const LoginBtn = styled.button`
  background: none;
  border: none;
  color: inherit;
  font-size: 0.65rem;
  font-family: monospace;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

export const Card = styled.div`
  background: ${({ theme }) => getOppositeBackground(theme)};
  color: ${({ theme }) => getOppositeText(theme)};
  border: 1px solid ${({ theme }) => theme.primary};
  padding: 1.5rem;
  max-width: 360px;
  width: 90%;
  font-family: monospace;
`;

export const Title = styled.h2`
  font-size: 0.85rem;
  letter-spacing: 0.1em;
  margin: 0 0 0.5rem 0;
  opacity: 0.9;
`;

export const Description = styled.p`
  font-size: 0.75rem;
  opacity: 0.7;
  line-height: 1.5;
  margin: 0 0 1.25rem 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Input = styled.input`
  background: transparent;
  border: 1px solid currentColor;
  padding: 0.6rem 0.75rem;
  font-size: 0.75rem;
  font-family: monospace;
  color: inherit;
  outline: none;
  opacity: 0.8;

  &:focus {
    opacity: 1;
  }

  &::placeholder {
    color: inherit;
    opacity: 0.4;
  }
`;

export const Button = styled.button`
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.background};
  border: none;
  padding: 0.6rem 0.75rem;
  font-size: 0.7rem;
  font-family: monospace;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  border: 1px solid currentColor;
  color: inherit;
  padding: 0.6rem 0.75rem;
  font-size: 0.7rem;
  font-family: monospace;
  cursor: pointer;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;

export const Message = styled.p<{ $type?: 'success' | 'error' }>`
  font-size: 0.7rem;
  opacity: ${({ $type }) => ($type ? 1 : 0.6)};
  color: ${({ $type }) =>
    $type === 'success' ? '#22c55e' : $type === 'error' ? '#ef4444' : 'inherit'};
  margin: 0;
`;
